export const BID_STEP = 500;
export const BID_MAX_LENGTH = 7;
export const BUDGET_STEP = 10000;
export const BUDGET_MAX_LENGTH = 7;
export const MINIMAL_BUDGET_IN_CENTS = 150000;
export const OPTIMAL_BUDGET_IN_CENTS = 300000;
export const MAXIMAL_BUDGET_IN_CENTS = 800000;

// Эту сумму прибавляем к предельной ставке
export const AUTO_STRATEGY_BID_STEP_IN_CENTS = 100;

export const DEFAULT_AUCTION_AUTO_STRATEGY_SETTINGS = {
    applicationsGrowthPercent: 18,
    applicationsCostReductionPercent: 33,
};
